import Link from "next/link";
import TrendingNowCard from "./trending-now-card";
import { InfiniteList } from "@components/core/infinite-list";
import { useRouter } from "next/router";
import {
  NewsPageQuery,
  NewsQuery,
  useNewsListQuery,
} from "@graphql/generated/graphql";
import { Trans } from "@lingui/macro";

interface ITrendingNow {}

const TrendingNow: React.FunctionComponent<ITrendingNow> = () => {
  const { locale } = useRouter();

  const { data, loading, fetchMore, error } = useNewsListQuery({
    variables: {
      type: NewsQuery.Category,
      categoryName: "Trending",
      limit: 20,
      languageCodes: [locale],
    },
  });

  return (
    <div className="">
      <p className="mt-12 px-4 pb-8 font-poppins text-xl font-bold text-text-darkest">
        <Trans>Trending right now</Trans>
        <div className="mt-4 h-[1px] w-full bg-off-white"></div>
      </p>

      {data && !error && (
        <InfiniteList
          infiniteLoadingOption={{
            dataLength: data.allNews.length || 0,
            next: () =>
              fetchMore({
                variables: {
                  limit: 20,
                  offset: data.allNews.length,
                  languageCodes: [locale],
                },
              }),
            loader: (
              <p className="py-4 text-center font-sen text-text-lightest">
                <Trans>Loading...</Trans>
              </p>
            ),
          }}
        >
          <div className="divide-y divide-off-white md:grid md:grid-cols-2 md:gap-x-6 md:gap-y-8 md:divide-y-0">
            {data.allNews.map((news) => (
              <div className="py-3" key={news.id}>
                <Link href={`/news/${news.id}`} passHref key={news.id}>
                  <a>
                    <TrendingNowCard news={news} />
                  </a>
                </Link>
              </div>
            ))}
          </div>
        </InfiniteList>
      )}
      {(loading || error) && (
        <div className="py-64 text-center font-sen text-text-lightest">
          <Trans>Loading...</Trans>
        </div>
      )}
    </div>
  );
};
export default TrendingNow;
